import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { ISwimlaneView } from './ControlSwimlane'

/**
 * Properties passed to the delete swimlane modal component.
 */
export interface IDeleteSwimlaneModalProps {
    swimlane: ISwimlaneView
    onConfirm: () => void
    onCancel: () => void
}

function DeleteSwimlaneModalComponent(props: IDeleteSwimlaneModalProps) {
    return (
        <Modal show={true}>
            <Modal.Header>
                <Modal.Title>Delete Swimlane with tasks?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    By deleting this swimlane you will also delete{' '}
                    {props.swimlane.taskIds.length} task
                    {props.swimlane.taskIds.length > 1 ? 's' : ''}. <br />
                    Are you sure?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={props.onConfirm}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteSwimlaneModalComponent
